export const classes = {
  app: 'h-screen w-screen absolute top-0 left-0 overflow-hidden bg-no-repeat bg-cover bg-site-background',
  notFound:
    'w-full h-full text-2xl text-grey-7 place-center bg-site-background',
};
